import { Button } from "react-bootstrap";
import useCustomer from "../../../context/CustomerContext";
import Contract from "../../Customer/Contract";

const DivisionRateCard = ({ CompanyProfileID, hasRateCard }) => {
    // UPDATE RATE CARD CACHE AFTER ADD 
    const { validateContractPricing } = useCustomer();

    return (
        <>
            {hasRateCard == null ? <div className="d-flex justify-content-end mb-3" >
                <Button style={{ maxWidth: "200px" }} onClick={() => validateContractPricing(0, { EntityType: "DIVISION", CompanyProfileID })} >Add Rate Card</Button>
            </div > : null}
            <Contract hideSpecialAddress component="COMPANY_PROFILE" />
        </>
    )
}

export default DivisionRateCard;